import ContentLoader from "react-content-loader";
import { Wrapper } from "./InstallationDetailTile.styles";
import useCoreContext from "@gf-core/widgets/hooks/useCoreContext";

export default function Loader() {
  const { theme } = useCoreContext();

  return (
    <Wrapper>
      <ContentLoader
        speed={1.2}
        backgroundColor={theme.core.colors.background.layers[700]}
        foregroundColor={theme.core.colors.background.layers[500]}
        style={{
          width: "100%",
          height: 450,
        }}
      >
        <rect x="0" width="100%" rx={4} height="450px" />
      </ContentLoader>
    </Wrapper>
  );
}
